import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const JournalBook = () => {
  return (
    <div className="space-y-4">
      <Card className="glass shadow-lg border-0">
        <CardHeader>
          <CardTitle>Journal Book</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-gray-600 dark:text-gray-200">
            Numora Journal Book module is ready for implementation.
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default JournalBook;

